import React from 'react';
import { ListItem, Tooltip } from '@ds';
import UserMenuOrganizationInfo from './UserMenuOrganizationInfo';
import styles from './UserMenuOrganization.module.scss';
import UserMenuOrganizationSelector from './UserMenuOrganizationSelector';

type UserMenuOrganizationItemProps = {
  onClick: React.MouseEventHandler;
  avatarLetters: string;
  avatarUrl: string;
  title: string;
  dataTestId: string;
  isActive?: boolean;
  showRightArrow?: boolean;
  isReadonly?: boolean;
  isGuestUser?: boolean;
};

const UserMenuOrganizationItem: React.FC<UserMenuOrganizationItemProps> = ({
  onClick,
  avatarLetters,
  avatarUrl,
  title,
  dataTestId,
  isActive = false,
  showRightArrow = false,
  isReadonly = false,
  isGuestUser = false
}) => {
  return (
    <ListItem
      onClick={onClick}
      active={isActive}
      isReadonly={isReadonly}
      data-test={dataTestId}
      className={styles.organizationItem}
    >
      <Tooltip content={title} wrapperDisplay="block">
        <UserMenuOrganizationInfo
          avatarLetters={avatarLetters}
          avatarUrl={avatarUrl}
          title={title}
          isActive={isActive}
          isGuestUser={isGuestUser}
        />
      </Tooltip>

      {showRightArrow && (
        <ListItem.Submenu
          offset="0 2px 0 0"
          iconSize="16px"
          placement="left-start"
        >
          <div className={styles.organizationSelectContainer}>
            <UserMenuOrganizationSelector currentOrganizationName={title} />
          </div>
        </ListItem.Submenu>
      )}
    </ListItem>
  );
};

export default UserMenuOrganizationItem;
